import { Injectable } from "@angular/core";

@Injectable()
export class restURL {

  public key: string = "ACIG18";

  // ///////////////////CLIENT UAT/////////////////////// 
  // public baseURL: string = "http://localhost:31579/API/";
  // //public baseURL:string="https://lbc.ggi-sa.com/TestB2BUatApi/API/";
  // // baseURL:string="https://lbc.ggi-sa.com/TestB2BMedmalApi/API/";
  // // public baseURL:string="https://lbc.ggi-sa.com/TestGGIonlineApi/API/";
  // public LimraOnlinePaymentsURL: string = "https://lbc.ggi-sa.com/LimraOnlinePaymentsUat/API"
  // public reportURL: string = "https://ubc.ggi-sa.com/";
  // public UpgradeURL:string="https://ubc.ggi-sa.com/TestMotorUpgradeApi/API/";
  // public MakeImagebaseURL: string = "https://lbc.ggi-sa.com/TestGGIOnlineApi/Makes/";
  // public PrintURL: string = "https://lbc.ggi-sa.com/TestPrints/";
  // public DocumentURL:string="https://lbc.ggi-sa.com/TestB2BUatApi/"
  // public AttachmentUrl: string = "https://lbc.ggi-sa.com/LimraAttachments/TPLAttachments/";
  // public AttachemntsMedmalURL: string = "https://lbc.ggi-sa.com/LimraAttachments/MedmalAttachmentsTest/";
  // public ClaimsAttachmentUrl: string = "https://lbc.ggi-sa.com/LimraAttachments/ClaimsAttachments/";
  // public TravelCancellationAttachment: string = "https://lbc.ggi-sa.com/LimraAttachments/TestTravelCancellationAttachments/";




  ///////////////////////LOCAL

  // // //public baseURL: string = "http://localhost:31579/API/";
  // public baseURL: string = "http://192.168.0.82/TestLimra2Api/API/";
  // public LimraOnlinePaymentsURL: string = "https://ubc.ggi-sa.com/LimraOnlinePaymentsUat/API"
  // public reportURL: string = "https://ubc.ggi-sa.com/";
  // public UpgradeURL: string = "http://192.168.0.82/TestMotorUpgradeApi/API/";
  // public MakeImagebaseURL: string = "http://localhost:31579/API/";
  // public PrintURL: string = "https://ubc.ggi-sa.com/LIMRA_REPORTS_UAT/";
  // public DocumentURL:string="https://ubc.ggi-sa.com/TestGGIOnlineApi/";
  // public AttachmentUrl: string = "http://192.168.0.82/LimraAttachments/TPLAttachments/";
  // public ClaimsAttachmentUrl: string = "https://lbc.ggi-sa.com/LimraAttachments/ClaimsAttachments/";
  // public AttachemntsMedmalURL: string = "http://192.168.0.82//LimraAttachments/MedmalAttachmentsTest/";



  // ///////////////////////////82 LOCAL
  // public baseURL: string = "http://192.168.0.82/TestLimra2Api/API/";
  // public baseURL: string = "http://192.168.0.82/TestOnlineApiGGI/API/";
  // public LimraOnlinePaymentsURL: string = "https://lbc.ggi-sa.com/LimraOnlinePaymentsLive/API";
  // public reportURL: string = "https://lbc.ggi-sa.com/";
  // public UpgradeURL: string = "https://lbc.ggi-sa.com/MotorUpgradeApiLive/API/";
  // public MakeImagebaseURL: string = "http://192.168.0.82/TestOnlineApiGGI/Makes/";
  // public PrintURL: string = "https://lbc.ggi-sa.com/PrintsLive/";
  // public DocumentURL: string = "http://192.168.0.82/TestOnlineApiGGI/";
  // public AttachmentUrl: string = "http://192.168.0.125//LimraAttachments/TPLAttachments/";
  // public ClaimsAttachmentUrl: string = "http://192.168.0.82/LimraAttachments/ClaimsAttachments/";
  // public AttachemntsMedmalURL: string = "http://192.168.0.82//LimraAttachments/MedmalAttachmentsTest/";
  // public TravelCancellationAttachment: string = "http://192.168.0.82/LimraAttachments/TestTravelCancellationAttachments/";

  // public baseURL: string = "http://192.168.0.82/TestOnlineApiGGI/API/";
  // public LimraOnlinePaymentsURL: string = "https://192.168.0.82/LimraOnlinePaymentsUat/API"
  // public reportURL: string = "https://ubc.ggi-sa.com/";
  // public UpgradeURL: string = "http://192.168.0.82/TestMotorUpgradeApi/API/";
  // public MakeImagebaseURL: string = "http://192.168.0.82/TestMotorUpgradeApi/API/";
  // public PrintURL: string = "http://192.168.0.125/GGCI_REPORTS_UAT/";
  // public DocumentURL:string="http://192.168.0.125/TestGGIOnlineApi/"


  //// LIVE Mobile App
  // public baseURL: string = "http://.sa/ACIGServicesMobileAppAPI/API/";
  // public LimraOnlinePaymentsURL: string = "https://eservices.acig.com.sa/LimraOnlinePaymentsLive/API";
  // public reportURL: string = "https://ubc.ggi-sa.com/";
  // public UpgradeURL:string="https://eservices.acig.com.sa/MotorUpgradeApiLive/API/";

  // // LIVE
  public baseURL: string = "https://lbc.ggi-sa.com/B2CApiLive/API/";
  public LimraOnlinePaymentsURL: string = "https://lbc.ggi-sa.com/LimraOnlinePaymentsLive/API"
  public reportURL: string = "https://lbc.ggi-sa.com/";
  public UpgradeURL: string = "https://lbc.ggi-sa.com/MotorUpgradeApiLive/API/";
  public MakeImagebaseURL: string = "https://lbc.ggi-sa.com/B2CApiLive/Makes/";
  public PrintURL: string = "https://lbc.ggi-sa.com/PrintsLive/";
  public DocumentURL: string = "https://lbc.ggi-sa.com/B2CApiLive/";
  public AttachmentUrl: string = "https://lbc.ggi-sa.com/LimraAttachments/TPLAttachments/";
  public ClaimsAttachmentUrl: string = "https://lbc.ggi-sa.com/LimraAttachments/ClaimsAttachments/";
  public AttachemntsMedmalURL: string = "https://lbc.ggi-sa.com/LimraAttachments/MedmalAttachments/";
  public TravelCancellationAttachment: string = "https://lbc.ggi-sa.com/LimraAttachments/TravelCancellationAttachments/";


  // // // ng build  --configuration "production" --aot --base-href /B2CLive/

  


}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/restURL.ts